import BoxUploadDocumentButton from './BoxUploadDocumentButton';

export default BoxUploadDocumentButton;
